import React from 'react';
import { Box } from "@mui/system";
import { COLORS } from "../../../../ui/Theme";
import {
    Card,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Link } from "react-router-dom";
import Grid2 from "@mui/material/Unstable_Grid2";

const DerivativesStrategiesDetailsAction = ({
    title,
    symbol,
    borderColor,
    icon,
    lastUpdate,
    link,
    price,
    orderBookTableData
}) => {

    return (
        <Grid2 xs={12} md={6} lg={4}>
            <Card
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    border: `1px solid ${borderColor}`,
                    padding: "24px 34px",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "16px",
                        }}
                    >
                        {icon}
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "8px",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: "20px",
                                    fontWeight: 700,
                                    color: COLORS.BLACK
                                }}
                            >
                                {title}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    color: COLORS.GRAY
                                }}
                            >
                                <span>نماد </span>
                                <span>{symbol}</span>
                                <span> با قیمت </span>
                                <span>{price + " "}</span>
                                <span>[آخرین معامله: {lastUpdate}]</span>
                            </Typography>
                        </Box>
                    </Box>
                    <Link to={link} style={{ alignSelf: "flex-start", }}>
                        <Tooltip title="سایت TSETMC">
                            <OpenInNewIcon
                                sx={{
                                    fontSize: "18px",
                                    color: COLORS.BLUE,
                                }}
                            />
                        </Tooltip>
                    </Link>
                </Box>
                <Box>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        sx={{
                                            textAlign: "center",
                                            color: COLORS.GREEN,
                                            backgroundColor: COLORS.SOFTGREEN,
                                            fontSize: "14px",
                                            fontWeight: 700
                                        }}
                                    >
                                        حجم خرید
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            textAlign: "center",
                                            color: COLORS.GREEN,
                                            backgroundColor: COLORS.SOFTGREEN,
                                            fontSize: "14px",
                                            fontWeight: 700
                                        }}
                                    >
                                        قیمت خرید
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            textAlign: "center",
                                            color: COLORS.RED,
                                            backgroundColor: COLORS.SOFTRED,
                                            fontSize: "14px",
                                            fontWeight: 700
                                        }}
                                    >
                                        قیمت فروش
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            textAlign: "center",
                                            color: COLORS.RED,
                                            backgroundColor: COLORS.SOFTRED,
                                            fontSize: "14px",
                                            fontWeight: 700
                                        }}
                                    >
                                        حجم فروش
                                    </TableCell>


                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {orderBookTableData.map((row) => (
                                    <TableRow key={row.row}>
                                        <TableCell
                                            sx={{
                                                textAlign: "center",
                                                color: COLORS.BLACK,
                                                fontSize: "14px",
                                                fontWeight: 400
                                            }}
                                        >
                                            {row.buy_volume}
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                textAlign: "center",
                                                color: COLORS.BLACK,
                                                fontSize: "14px",
                                                fontWeight: 400
                                            }}
                                        >
                                            {row.buy_price}
                                        </TableCell>

                                        <TableCell
                                            sx={{
                                                textAlign: "center",
                                                color: COLORS.BLACK,
                                                fontSize: "14px",
                                                fontWeight: 400
                                            }}
                                        >
                                            {row.sell_price}
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                textAlign: "center",
                                                color: COLORS.BLACK,
                                                fontSize: "14px",
                                                fontWeight: 400
                                            }}
                                        >
                                            {row.sell_volume}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Card>
        </Grid2>
    );
};

export default DerivativesStrategiesDetailsAction;